export default "__VITE_ASSET__DVoQu_j3__"